import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.625 3H6.375Q3 3 3 6.375v11.25Q3 21 6.375 21h11.25Q21 21 21 17.625V6.375Q21 3 17.625 3m-5.617 4a3 3 0 1 1 0 6 3 3 0 0 1 0-6m5.612 12.5H6.38c-.13 0-.25 0-.37-.01.13-1.7 1.09-3.92 4.28-3.92h3.42c3.18 0 4.15 2.24 4.28 3.92-.12.01-.24.01-.37.01"
    }, null, -1)
  ])))
}
export default { render: render }